import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

export class ZIDXAccountInvoice implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountInvoiceContainer";
    }
    render(){
        // console.log("invoice");
    }
}